const colConfig = {
  lg: 12,
  md: 6,
  sm: 12,
  xmd: 2,
};

export default colConfig;
